var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "add-deduction-modal-container" }, [
    _c(
      "div",
      {
        ref: "addDeductionModal",
        staticClass: "reveal add-deduction-modal",
        attrs: { id: "addDeductionModal", "data-reveal": "" },
      },
      [
        _c("div", { staticClass: "tender-confirm clearfix" }, [
          _c("div", { staticClass: "add-deduction-amount-row clearfix" }, [
            _c("div", { staticClass: "add-deduction-po-amount" }, [
              _c("label", { staticClass: "emphasis" }, [
                _vm._v(_vm._s(_vm.amountLabel)),
              ]),
              _vm._v(" "),
              _c("pre", [
                _c("p", [
                  _vm._v(
                    _vm._s(
                      _vm._f("formatCurrency")(_vm.purchase.amount, {
                        currencyCode: _vm.currencyCode,
                      })
                    )
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "add-deduction-revised-amount" }, [
              _c("label", { staticClass: "emphasis" }, [
                _vm._v(_vm._s(_vm.revisedLabel)),
              ]),
              _vm._v(" "),
              _c("pre", [
                _c("p", [
                  _vm._v(
                    _vm._s(
                      _vm._f("formatCurrency")(
                        _vm.purchase.amount - _vm.amount,
                        { force: true, currencyCode: _vm.currencyCode }
                      )
                    )
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "add-deduction-edit-amount" }, [
              _c("label", { staticClass: "emphasis" }, [
                _vm._v(_vm._s(_vm.$t("project.deduction.label"))),
              ]),
              _vm._v(" "),
              _vm.isContractor || !_vm.editable
                ? _c("pre", [
                    _c("p", [
                      _vm._v(
                        _vm._s(
                          _vm._f("formatCurrency")(_vm.amount, {
                            currencyCode: _vm.currencyCode,
                          })
                        )
                      ),
                    ]),
                  ])
                : _c("div", [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.currencyCode || _vm.$globalProps.getCurrency()
                        )
                      ),
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "fusioninputcheck",
                          rawName: "v-fusioninputcheck",
                          value: {
                            type: "decimal",
                            classes: "tooltip-class",
                            pattern: function (val) {
                              return (Number(val) || 0) >= 0
                            },
                          },
                          expression:
                            "{\n                type: 'decimal',\n                classes: 'tooltip-class',\n                pattern: (val) => (Number(val) || 0) >= 0,\n              }",
                        },
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.amount,
                          expression: "amount",
                        },
                      ],
                      attrs: {
                        type: "text",
                        id: "project-deduction-amount",
                        novalidate: "",
                      },
                      domProps: { value: _vm.amount },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.amount = $event.target.value
                        },
                      },
                    }),
                  ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("label", { staticClass: "emphasis" }, [
                _vm._v(_vm._s(_vm.$t("comment"))),
              ]),
              _vm._v(" "),
              _vm.isContractor || !_vm.editable
                ? _c("div", { staticClass: "deduction-comment" }, [
                    _vm._v("\n          " + _vm._s(_vm.reason) + "\n        "),
                  ])
                : _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.reason,
                        expression: "reason",
                      },
                      { name: "autosize", rawName: "v-autosize" },
                      {
                        name: "checkVisibility",
                        rawName: "v-checkVisibility",
                        value: { refresh: true },
                        expression: "{refresh: true}",
                      },
                    ],
                    staticClass: "autosize",
                    class: {
                      "error-highlight":
                        (_vm.reason || "").trim().length === 0 &&
                        _vm.validateForm,
                    },
                    attrs: {
                      type: "text",
                      id: "project-deduction-reason",
                      placeholder: _vm.$t("typeComments"),
                      autofocus: "",
                    },
                    domProps: { value: _vm.reason },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.reason = $event.target.value
                      },
                    },
                  }),
              _vm._v(" "),
              _c("label", { staticClass: "emphasis" }, [
                _vm._v(_vm._s(_vm.$t("attachments"))),
              ]),
              _vm._v(" "),
              _c("EditAttachments", {
                attrs: {
                  sourceId: _vm.deductionSrcId,
                  canEdit: _vm.editable,
                  canDelete: _vm.editable,
                  canDownloadAll: false,
                  action: _vm.getDeleteDocAction(),
                },
              }),
              _vm._v(" "),
              _c("HkldDropzone", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.editable,
                    expression: "editable",
                  },
                ],
                attrs: {
                  sourceId: _vm.deductionSrcId,
                  action: _vm.getCreateDocAction(),
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isContractor || !_vm.editable
            ? _c("div", { staticClass: "add-deduction-button-bar" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn--orange",
                    attrs: {
                      id: "confirm_no",
                      type: "button",
                      "data-close": "",
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("action.ok")))]
                ),
              ])
            : _c("div", { staticClass: "add-deduction-button-bar" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn--darkblue",
                    attrs: { id: "confirm_no", type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.cancel()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("action.cancel")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn--orange",
                    attrs: { id: "confirm_yes", type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.confirmDeduction()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("action.confirm")))]
                ),
              ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }